import React, { PureComponent } from 'react'

export default function searchBar({keyword,setKeyword}) {
  
    return (
        <div className='m-2'>
        <input className='form-control' 
        placeholder='Search' type="search" 
        onChange={(e) => setKeyword(e.target.value)} value={keyword} />
    </div>
    )
  }

